import { render } from "./GalleryMain.vue?vue&type=template&id=4ef0bb6e&scoped=true&lang=pug"
import script from "./GalleryMain.vue?vue&type=script&lang=js"
export * from "./GalleryMain.vue?vue&type=script&lang=js"

import "./GalleryMain.vue?vue&type=style&index=0&id=4ef0bb6e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ef0bb6e"]])

export default __exports__